<template>
  <colered-icon :color="value" :icon-class="'bi bi-square-fill'" :shadow="true"></colered-icon>
  {{ value }}
</template>

<script>
import ColeredIcon from '@kanrisha/components/Icons/ColoredIcon';

export default {
  components: {
    ColeredIcon,
  },
  props: {
    value: { type: String, default: '' },
  },
  setup() {
    return {};
  },
};
</script>
